module.exports = __webpack_public_path__ + "images/psp/Dirt-Bike/dirt-bike-10x10.svg";